exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ArticleList {\n  width: 90vw;\n  max-width: 1280px;\n  min-width: calc(360px - 10vw);\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  margin-top: 50px; }\n  .ArticleList ul {\n    margin-left: 0;\n    padding-left: 0; }\n  .ArticleList-Article_Wrapper {\n    margin-top: 20px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center; }\n", ""]);

// exports
